import { render, staticRenderFns } from "./trans-text.vue?vue&type=template&id=5d9b7b04&scoped=true&"
import script from "./trans-text.vue?vue&type=script&lang=js&"
export * from "./trans-text.vue?vue&type=script&lang=js&"
import style0 from "./trans-text.vue?vue&type=style&index=0&id=5d9b7b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b7b04",
  null
  
)

export default component.exports